module.exports = __webpack_public_path__ + "src/assets/img/handcuffs.2cdfd6c3.svg";